import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    data: []
};
const cpuSlice = createSlice({
    name: "cpu",
    initialState,
    reducers: {
        setLatestCPU (state, action) {
            state.latestCpuUtilization = action.payload.utilization;
        },
        setHistoricalData (state, action) {
            const { key, data } = action.payload;
            state[key] = data;
        },
        addCPUUtilizationDataPoint (state) {
            const now = Date.now();
            const oldestPoint = now - 60 * 60 * 1000;
            const filtered = state.data.filter((d)=>d.x >= oldestPoint);
            // Add the new data point using the latest CPU utilization
            if (state.latestCpuUtilization != null) {
                const newPoint = {
                    x: now,
                    y: state.latestCpuUtilization
                };
                state.data = [
                    ...filtered,
                    newPoint
                ];
            } else {
                state.data = filtered;
            }
        }
    }
});
export const { setLatestCPU, setHistoricalData, addCPUUtilizationDataPoint } = cpuSlice.actions;
export default cpuSlice.reducer;
